import { InfoOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

export interface InfoTooltipProps extends Omit<TooltipProps, 'children'> {}

function InfoTooltip(props: InfoTooltipProps) {
  return (
    <Tooltip {...props} placement={props.placement ?? 'top'}>
      <IconButton sx={{ ...props.sx, padding: '0', ml: '0.25rem' }}>
        <InfoOutlined
          sx={{
            color: props.color ?? 'gray',
            fontSize: '1.2rem',
            padding: '0',
          }}
        />
      </IconButton>
    </Tooltip>
  );
}

export default InfoTooltip;
